<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" fill-rule="evenodd" d="M19.5 12L6 19.5v-15L19.5 12z" clip-rule="evenodd"/>
</svg>
